export default function PolicyFramework() {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="font-serif text-4xl lg:text-5xl font-bold text-slate-900 mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              Our Policy Framework: Constitutional AI
            </h2>
            <p className="text-xl text-slate-700 leading-relaxed max-w-4xl mx-auto">
              We argue that "human-level performance" is a dangerous safety standard for AI. Instead, we advocate for <strong>Constitutional AI (CAI)</strong> as the regulatory gold standard.
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 mb-12">
            {/* From Inference to Constraint */}
            <div className="bg-slate-50 p-10 shadow-lg border-l-8 border-red-800">
              <div className="flex items-start mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-red-800 text-white mr-4 flex-shrink-0">
                  <i className="ri-arrow-right-line text-2xl"></i>
                </div>
                <h3 className="font-serif text-2xl font-bold text-slate-900" style={{ fontFamily: "'Playfair Display', serif" }}>
                  From Inference to Constraint
                </h3>
              </div>
              <p className="text-lg text-slate-700 leading-relaxed">
                We must stop asking AI to guess our values from our history (which is flawed) and start explicitly coding our values as constraints.
              </p>
            </div>

            {/* The Solution */}
            <div className="bg-slate-50 p-10 shadow-lg border-l-8 border-slate-900">
              <div className="flex items-start mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-slate-900 text-white mr-4 flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="font-serif text-2xl font-bold text-slate-900" style={{ fontFamily: "'Playfair Display', serif" }}>
                  The Solution
                </h3>
              </div>
              <p className="text-lg text-slate-700 leading-relaxed">
                High-stakes models must operate under a "Constitution"—a set of explicit, non-negotiable rules (e.g., "Do not discriminate based on protected class") that override the training data whenever the two conflict.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-slate-900 to-slate-800 text-white p-12 shadow-xl">
            <div className="flex items-start">
              <div className="w-16 h-16 flex items-center justify-center bg-red-800 text-white mr-6 flex-shrink-0">
                <i className="ri-lightbulb-line text-3xl"></i>
              </div>
              <div>
                <h3 className="font-serif text-3xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                  Key Principle
                </h3>
                <p className="text-xl leading-relaxed">
                  Constitutional AI ensures that AI systems align with our <strong>stated values</strong>, not our <strong>historical failures</strong>, creating transparent and accountable decision-making in critical infrastructure.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
